import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SetHealthScore({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Set Health Score</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Compliance & Trust */}
                            <div className="control_group w_50">
                                <label htmlFor="hs-compliance">Compliance & Trust (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "hs-compliance" }}
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>

                            {/* Order & Fulfillment */}
                            <div className="control_group w_50">
                                <label htmlFor="hs-order">Order & Fulfillment Performance (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "hs-order" }}
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>

                            {/* Customer Experience */}
                            <div className="control_group w_50">
                                <label htmlFor="hs-customer-exp">Customer Experience (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "hs-customer-exp" }}
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>

                            {/* Financial Reliability */}
                            <div className="control_group w_50">
                                <label htmlFor="hs-financial">Financial Reliability (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "hs-financial" }}
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>

                            {/* Engagement & Store Quality */}
                            <div className="control_group w_50">
                                <label htmlFor="hs-engagement">Engagement & Store Quality (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0 - 100"
                                    inputProps={{ min: 0, max: 100, id: "hs-engagement" }}
                                    fullWidth
                                    hiddenLabel
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save Score
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
